import mobilePhoneImg from 'styles/assets/mobile-phone.svg';

import {
  FacebookShareButton,
  FacebookIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share';
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import './shareItem.css';

const StyledAccordionSummary = styled(AccordionSummary)({
  minHeight: 30,
  '& .MuiAccordionSummary-content': {
    margin: '5px 0px',
  },
  '& .MuiIconButton-root': {
    padding: 0,
  },
});

const ShareButtonsContainer = styled('span')({
  display: 'flex',
  alignItems: 'center',
  marginTop: 5,
  '& > *': {
    margin: '0px 3px',
  },
});

export default function ShareItem({
  idPromo,
  imagePromo,
  titlePromo,
  descriptionPromo,
  textShare,
  uId,
  setOpenState,
}) {
  const urlPromo = `https://triibo.com.br/oferta/?id=${idPromo}&userid=${uId}&campaingid=fimano00`;
  const hashtag = 'fimDeAnoMalucoTriibo';

  const openGuestModal = () => {
    setOpenState(true);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{ alignItems: 'center', padding: '15px 0px', borderTop: '2px solid lightgrey' }}
    >
      <Grid size={{ xs: 12, sm: 4 }}>
        <img src={imagePromo} alt={idPromo} style={{ width: '100%' }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 8 }}>
        <div>
          <Typography variant="h6">{titlePromo}</Typography>
          <Accordion>
            <StyledAccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="caption">Detalhes da promoção</Typography>
            </StyledAccordionSummary>
            <AccordionDetails>
              <Typography variant="caption" style={{ lineHeight: 1, whiteSpace: 'pre-line' }}>
                {descriptionPromo}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <ShareButtonsContainer>
            {uId !== 'guest' ? (
              <>
                <Typography Typography variant="body1">
                  Compartilhe a promoção:{' '}
                </Typography>
                <FacebookShareButton url={urlPromo} hashtag={hashtag}>
                  <FacebookIcon size={40} round={true} />
                </FacebookShareButton>
                <TelegramShareButton url={urlPromo} title={textShare}>
                  <TelegramIcon size={40} round={true} />
                </TelegramShareButton>
                <TwitterShareButton url={urlPromo} title={textShare}>
                  <TwitterIcon size={40} round={true} />
                </TwitterShareButton>
                <WhatsappShareButton url={urlPromo} title={textShare}>
                  <WhatsappIcon size={40} round={true} />
                </WhatsappShareButton>
              </>
            ) : (
              <button className="btn-identity" onClick={() => openGuestModal()}>
                <span className="btn-content">
                  <img width="22px" src={mobilePhoneImg} alt="phone" />
                  Se identifique e participe!
                </span>
              </button>
            )}
          </ShareButtonsContainer>
        </div>
      </Grid>
    </Grid>
  );
}
